import type { ItemType, SubjectType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

export type IsBenchmarkParams = {
  uid?: string
  item?: ItemType
  subject?: SubjectType
}

const externalDataEx = /(^b[\da-z]+$)|(^.*-benchmark@is.aytm$)/
const averageDataEx = /^avg$|^row_averages@is\.aytm$/

export const isBenchmark = ({ uid, item, subject }: IsBenchmarkParams = {}) => {
  const subjectUid = uid ? uid : item?.uid ? item.uid : subject?.uid ?? ''
  return externalDataEx.test(subjectUid)
}

export const isRowAverages = ({ uid, item, subject }: IsBenchmarkParams = {}) => {
  const subjectUid = uid ? uid : item?.uid ? item.uid : subject?.uid ?? ''
  return averageDataEx.test(subjectUid)
}
